import { Location } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-candidate-navbar',
  templateUrl: './candidate-navbar.html',
})
export class CandidateNavbar {
  private readonly route = inject(ActivatedRoute);
  stored = localStorage.getItem('inviteData');
  parsed = JSON.parse(this.stored!);
  email = signal<string | null>(null);
  private location = inject(Location);
  private router = inject(Router);
  private currentUrl = signal(this.router.url);
  //check if url are /exam/id or not
  showBack = computed(() => {
    const url = this.currentUrl();
    return !/^\/exam\/[^/]+$/.test(url);
  });

  constructor() {
    //set current url
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        )
      )
      .subscribe(event => this.currentUrl.set(event.urlAfterRedirects));
    // อ่าน localStorage และอัปเดต email เมื่อสร้าง component
    const stored = localStorage.getItem('inviteData');
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        this.email.set(parsed?.data?.email ?? null);
      } catch {
        this.email.set(null);
      }
    } else {
      const email = this.route.snapshot.queryParamMap.get('email') || '';
      this.email.set(email);
    }
  }

  goBack() {
    this.location.back();
  }
}
